"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findAll = findAll;
exports.remove = remove;
exports.visible = visible;
var _request = _interopRequireDefault(require("@/utils/request"));
function findAll(listQuery) {
  return (0, _request.default)({
    url: "/rateStore",
    method: "get",
    params: listQuery
  });
}
function visible(storeId, data) {
  return (0, _request.default)({
    url: "/rateStore/".concat(storeId, "/visible"),
    method: "patch",
    data: data
  });
}
function remove(storeId) {
  return (0, _request.default)({
    url: "/rateStore/".concat(storeId),
    method: "delete"
  });
}